import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import AboutHero from './components/AboutHero';
import CoreCompetencies from './components/CoreCompetencies';
import Background from './components/Background';

export default function AboutPage() {
  const { t } = useTranslation();

  return (
    <div className="bg-canvas font-inter">
      <Navbar />
      <main>
        <AboutHero />
        <Background />
        <CoreCompetencies />
      </main>
      <Footer />
    </div>
  );
}
